import { Location } from '@cobliteam/common-types';
import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { Link } from 'react-router-dom';

type PageErrorProps = {
  message?: string;
  showLogo?: boolean;
};

function PageError({ message, showLogo = false }: PageErrorProps) {
  const { t } = useTranslation('ui-business');

  return (
    <div data-testid='page-error' key='page-error' className='relative flex h-full flex-col items-center justify-center gap-4 text-center'>
      {showLogo && <div className='absolute top-0 left-0 p-4'>{/* You can import and use your logo here if needed */}</div>}
      <Icon name='file-x' size='4xl' />
      <Typography variant='heading-2xl' className='font-bold' as='h1'>
        {message || t('page_error.unexpected')}
      </Typography>
      <Typography variant='input-placeholder'>{t('page_error.fixing_soon')}</Typography>
      <Link to={Location.HOME}>
        <Button variant='ghost' startIcon={<Icon name='rotate-cw' />} onClick={() => window.location.reload()}>
          {t('page_error.try_again')}
        </Button>
      </Link>
    </div>
  );
}

export default PageError;
